import { render, staticRenderFns } from "./categoriesMenu.vue?vue&type=template&id=5fb64e0f&scoped=true&"
import script from "./categoriesMenu.vue?vue&type=script&lang=js&"
export * from "./categoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./categoriesMenu.vue?vue&type=style&index=0&id=5fb64e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb64e0f",
  null
  
)

export default component.exports